import { FormattedMessage } from "react-intl";
import DownloadIconSmall from "../../../../components/Common/SvgIcons/CommonIcons/DownloadIconSmall";
import DeleteIcon from "../../../../components/Common/SvgIcons/TableIcons/DeleteIcon";
import EditIcon from "../../../../components/Common/SvgIcons/TableIcons/EditIcon";
import ViewIcon from "../../../../components/Common/SvgIcons/TableIcons/ViewIcon";
import Tooltip from "../../../../components/Common/ToolTip/Tooltip";
import { tableColumnTypes } from "../../../tableColumnTypes";
import { admin } from "../admin";
import sampleCertificate from "../../../../assets/downloads/Samplecertificate.pdf";

export const certificateManagement = {
  name: <FormattedMessage id="Cert_Manage" />,
  path: (tenantName) => `${admin.path(tenantName)}/certificateManagement`,
  downloadSampleCertificateLink: sampleCertificate,
  navLinks: (navigate, tenantName) => [
    {
      key: 1,
      label: admin.name,
      path: admin.path(tenantName),
      onClick: () => navigate(admin.path(tenantName)),
    },
    {
      key: 2,
      label: certificateManagement.name,
      path: certificateManagement.path(tenantName),
      onClick: () => navigate(certificateManagement.path(tenantName)),
    },
  ],
  columns: (
    handleManageCertificateModal,
    handleDeleteCertificateModal,
    handleViewCertificateModal
  ) => [
    {
      ID: 1,
      name: <FormattedMessage id="CERTIFICATE_NAME" />,
      fieldName: "Name",
      value: (row) => row.Name,
      sort: true,
      type: tableColumnTypes.STRING,
    },
    {
      ID: 2,
      name: <FormattedMessage id="Cer_Creator" />,
      fieldName: "CreatorName",
      value: (row) => row.CreatorName,
      sort: true,
      type: tableColumnTypes.STRING,
    },
    {
      ID: 3,
      name: <FormattedMessage id="MYCLASS_DATEMODIFY" />,
      fieldName: "Modified",
      value: (row) => new Date(row.Modified).toLocaleString(),
      sort: true,
      type: tableColumnTypes.DATE,
    },
    {
      ID: 4,
      name: <FormattedMessage id="Cer_Actions" />,
      fieldName: "",
      value: (row) => (
        <>
          <Tooltip
            content={<FormattedMessage id="VIEW_SHOTCLASS_HOME" />}
            direction={"bottom"}
          >
            <span onClick={() => handleViewCertificateModal(row.CertificateID)}>
              <ViewIcon />
            </span>
          </Tooltip>
          <Tooltip
            content={<FormattedMessage id="MYCLASS_EDIT" />}
            direction={"bottom"}
            show={row?.IsAuthorized}
          >
            <span
              style={{ visibility: row?.IsAuthorized ? "visible" : "hidden" }}
              onClick={() => handleManageCertificateModal(row.CertificateID)}
            >
              <EditIcon />
            </span>
          </Tooltip>
          <Tooltip
            content={<FormattedMessage id="DOWNLOAD_LBL" />}
            direction={"bottom"}
          >
            <span onClick={() => window.open(row?.CertificateUrl)}>
              <DownloadIconSmall />
            </span>
          </Tooltip>
          <Tooltip
            content={<FormattedMessage id="DELETE_TXT" />}
            direction={"bottom"}
            show={row?.IsAuthorized}
          >
            <span
              style={{ visibility: row?.IsAuthorized ? "visible" : "hidden" }}
              onClick={() => handleDeleteCertificateModal(row.CertificateID)}
            >
              <DeleteIcon />
            </span>
          </Tooltip>
        </>
      ),
      sort: false,
    },
  ],
};
